<template>
    <div class="row h-100">
        <div
            class="col-5 algolia-listing-product-block__product-pricing-wrapper algolia-listing-product-block__product-pricing-wrapper--sale pr-0"
        >
            <div
                v-if="isBelgiumShop"
                class="algolia-listing-product-block__product-price algolia-listing-product-block__product-price--advantage-label"
            >
                <span class="d-none d-md-inline">Prijsvoordeel</span>
                <span class="d-md-none">Voordeel</span>
            </div>
            <div
                v-else-if="combination.price_from_display"
                class="algolia-listing-product-block__product-price algolia-listing-product-block__product-price--sale-b" v-text="combination.price_from_display"
            >
            </div>
            <div
                v-else-if="combination.price_from"
                class="algolia-listing-product-block__product-price algolia-listing-product-block__product-price--sale-b"
            >
                {{ combination.price_from }}
            </div>
        </div>
        <div
            class="col-7 algolia-listing-product-block__product-sale-pricing-wrapper-single-product pr-0 pr-lg-3"
        >
            <div
                class="algolia-listing-product-block__product-sale-price-per-kg"
                v-text="combination.price_punit_for ? combination.price_punit_for.replace(/[()]/g , '') : combination.price_pkilo_for.replace(/[()]/g , '')"
            >
            </div>
            <div class="algolia-listing-product-block__product-sale-price" itemprop="price">
                {{ combination.price_for_display }}
            </div>
            <div class="algolia-listing-product-block__product-sale-price-subnote-b algolia-listing-product-block__product-sale-price-subnote-b--green algolia-listing-product-block__product-sale-price-subnote-b--uppercase" v-if="combination.discount_percentage && !isBelgiumShop">{{ $t('myAccount.saving')}}: {{ combination.discount_percentage }}%</div>
        </div>
        <meta itemprop="availability" href="https://schema.org/InStock" />
    </div>
</template>

<script>
import { isBelgiumShop } from "../../../../js/helper/shop-helper";

export default {
    name: "PricingReduction",
    props: {
        combination: {
            type: Object,
            required: true
        }
    },
    computed: {
        isBelgiumShop() {
            return isBelgiumShop();
        }
    }
};
</script>
